import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-upload-success',
  templateUrl: './upload-success.component.html',
  styleUrls: ['./upload-success.component.css']
})
export class UploadSuccessComponent implements OnInit {

  title: string;
  subHeader: string;
  currentYear: string = new Date().getFullYear().toString();

  constructor() {
    this.title = `Thank You for Partnering with ATD`;
    this.subHeader = `Your documents have been successfully uploaded! Thank you!`;
  }

  ngOnInit() {
  }

}
